import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth
export const login = async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
};

export const verifyAuth = async () => {
    const response = await api.get('/auth/verify');
    return response.data;
};

// Carriers
export const getCarriers = async () => {
    const response = await api.get('/carriers');
    return response.data;
};

// Packages
export const getPackages = async (archived = false) => {
    const response = await api.get('/packages', { params: { archived } });
    return response.data;
};

export const getPackage = async (id) => {
    const response = await api.get(`/packages/${id}`);
    return response.data;
};

export const createPackage = async (data) => {
    const response = await api.post('/packages', data);
    return response.data;
};

export const createBulkPackages = async (data) => {
    const response = await api.post('/packages/bulk', data);
    return response.data;
};

export const deletePackage = async (id) => {
    const response = await api.delete(`/packages/${id}`);
    return response.data;
};

export const updatePackage = async (id, data) => {
    const response = await api.put(`/packages/${id}`, data);
    return response.data;
};

export const archivePackage = async (id) => {
    const response = await api.post(`/packages/${id}/archive`);
    return response.data;
};

export const unarchivePackage = async (id) => {
    const response = await api.post(`/packages/${id}/unarchive`);
    return response.data;
};

export const refreshPackage = async (id) => {
    const response = await api.post(`/packages/${id}/refresh`);
    return response.data;
};

export const refreshAllPackages = async () => {
    const response = await api.post('/packages/refresh-all');
    return response.data;
};

// Settings
export const getSettings = async () => {
    const response = await api.get('/settings');
    return response.data;
};

export const updateSettings = async (data) => {
    const response = await api.put('/settings', data);
    return response.data;
};

// Update Shippo API key
export const updateShippoApiKey = async (apiKey) => {
    const currentSettings = await getSettings();
    const response = await api.put('/settings', {
        ...currentSettings,
        shippo_api_key: apiKey
    });
    return response.data;
};

// Test Shippo API connection
export const testConnection = async (apiKey = null) => {
    const response = await api.post('/test-connection', null, {
        params: apiKey ? { api_key: apiKey } : {}
    });
    return response.data;
};

// Change password
export const changePassword = async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword
    });
    return response.data;
};

// Get next scheduled check time
export const getNextCheckTime = async () => {
    const response = await api.get('/settings/next-check');
    return response.data;
};

export default api;
